module.exports = __webpack_public_path__ + "img/20200611.465c0e6e.png";